export const API_URL_PREFIX = '/api/';
export const BEARER_PREFIX = 'Bearer ';
